import { GeoSearch } from '@aloft/toolkit-shared';

import { MapAlert } from './MapAlert.tsx';

type MapAlertsProps = {
  geoSearch: GeoSearch;
};

export const MapAlerts = ({ geoSearch }: MapAlertsProps) => {
  if (geoSearch.t === 'polygon') {
    if (!geoSearch.coords.length) {
      return (
        <MapAlert>Define a geographical boundary by drawing a polygon (‘Esc’ to cancel).</MapAlert>
      );
    }

    return <MapAlert>Click on "Apply" to search comps with the current polygon.</MapAlert>;
  }

  return <MapAlert>Click on "Apply" to search comps with the current radius.</MapAlert>;
};
